/**
 * Route constants
 */
export const NEXT_URL = {
  SYSTEM_LP: "https://yoyacoo.jp/",
  SYSTEM_LP_REFERRAL: "https://yoyacoo.jp/?utm_source=poweredby&utm_medium=referral&utm_campaign=public_page",
  FORM_CONFIRM: "/form/[uuid]/confirm",
  SUBSCRIPTION_CONFIRM: "/subscription/[uuid]/confirm",
  SUBSCRIPTION_PURCHASE_CONFIRM: "/subscription/[uuid]/purchase/confirm",
  UNSUBCRIBE_PAGE: "/mails/unsubcribe/[user_id]",
  UNSUBCRIBE_SUCCESS_PAGE: "/mails/unsubcribe/[user_id]/success",
  CONTACT: "https://yoyacoo.jp/customer/lp/gsn666eab3c7bbfc",
};
